"use client";

import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";

const TotalOrders = ({ data }) => {
  const [Chart, setChart] = useState();

  useEffect(() => {
    import("react-apexcharts").then((mod) => {
      setChart(() => mod.default);
    });
  }, []);

  // ✅ TEMP chart (replace later with real trend API)
  const series = [
    {
      name: "Active %",
      data: [60, 50, 40, 50, 45, 30, 50],
    },
  ];

  const options = {
    chart: {
      toolbar: { show: false },
    },
    colors: ["#AD63F6"],
    plotOptions: {
      bar: {
        borderRadius: 3,
        columnWidth: "9px",
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      labels: { show: false },
    },
    yaxis: { show: false },
    grid: { show: false },
  };

  // ✅ Calculate Active %
  // adjust keys based on your backend response
  const total = data?.today_total || 0;
  const active = data?.today_active || 0;

  const activePercent =
    total > 0 ? Math.round((active / total) * 100) : 0;

  // ✅ Comparison (weekly)
  const change = data?.change_week || 0;
  const isUp = change >= 0;

  return (
    <Card className="border bg-white rounded-3 overflow-hidden mb-4">
      
      {/* Top */}
      <div className="d-flex align-items-center p-4 pb-3 mb-1">
        <div className="flex-shrink-0">
          <div
            className="wh-55 bg-primary-div bg-opacity-25 text-center rounded-2"
            style={{ lineHeight: "55px" }}
          >
            <i className="ri-timer-line fs-22 bg-primary-div text-white rounded-2 p-2"></i>
          </div>
        </div>

        <div className="flex-grow-1 ms-3">
          <h3 className="fs-24 fw-medium mb-0">
            {data ? `${activePercent}%` : "--"}
          </h3>
          <span>Active Time %</span>
        </div>
      </div>

      {/* Change */}
      <div className="d-flex align-items-center p-4 pb-0">
        <span
          className={`d-inline-block ${
            isUp
              ? "bg-success text-success border-success"
              : "bg-danger text-danger border-danger"
          } bg-opacity-10 border rounded-pill px-2 fw-medium d-flex align-items-center fs-12`}
        >
          <i className={`ri-arrow-${isUp ? "up" : "down"}-fill fs-14 lh-1`}></i>
          {Math.abs(change)}%
        </span>

        <span className="ms-2 fs-12">from last week</span>
      </div>

      {/* Chart */}
      <div style={{ margin: "-45px -11px -31px -15px" }}>
        {Chart && (
          <Chart
            options={options}
            series={series}
            type="bar"
            height={119}
          />
        )}
      </div>
    </Card>
  );
};

export default TotalOrders;